import { PurchaseOrder } from "@models/PurchaseOrder";

export const poTypeLabel = (poType: PurchaseOrder["type"]) => {
  return {
    "pre-order": "Pre-Order",
    "on-demand": "On-Demand",
    fulfillment: "Fulfillment",
    inventory: "Inventory",
  }[poType];
};
